import getData from '@/services/api/internal/heatingIgnition/assets_properties_data.api';

export default function getPropertiesAdditionnalData(items) {
  const idList = items.map((item) => item.id);
  return getData(idList);
}
